import React from "react";
import Modal from "react-modal";
import { Button } from "../../common/Button/Button"
import ModalContent from "../../common/Modal/ModalContent";
import Spinner from "../../common/Spinner/Spinner";
import close_modal from "./../../assets/ic_close_wh.svg";
Modal.setAppElement("#root");


export default function TestimonialDeleteConfirmationModel(props) {
    const handleDeleteYes = () => {
        if (props.iconClickedName == "text") {
            props.handleDelete(props.iconClickedName);
        }
        if (props.iconClickedName == "video" || props.iconClickedName == "audio") {
            props.handleDeleteVideo(props.iconClickedName);
        }
    }


    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.toggleModal}
            ariaHideApp={false}
            style={{
                overlay: {
                    zIndex: 10,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                }
            }}
        >
            <ModalContent className="general-modal">
                <div className="modal-header">
                    <span className="modal-title">Delete Testimonial</span>
                    <img
                        alt="close"
                        id="Close"
                        src={close_modal}
                        className="close modal-close"
                        onClick={props.toggleModal}
                    />
                </div>
                <div className={`modal-body notes-trail-content conv-pl25 conv-pr25 custom-scrollbar ${props.isLoading && "set-opacity"}`}>
                    {props.deleteModalLoading && <Spinner className="center" />}
                    <div className="conv-mt10">
                        <p>{`Are you sure you want to delete the ${props.iconClickedName} testimonial?`}</p>
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                        <Button
                            type="button"
                            // disabled={props.deliveryMode === "Self-Served" ||props.isDisabled === "disabled"}
                            // className={`my-services-model-submit-btn conv-pr15 conv-pl15 conv-mt10 conv-mb10
                            // ${props.deliveryMode === "Self-Served" ||props.isDisabled === "disabled"?"disabled":""}`}
                            onClick={() => handleDeleteYes()}
                        // disabled={props.deleteModalLoading ? true : false}
                        >
                            Yes
                        </Button>

                        <Button
                            type="button"
                            // disabled={props.deliveryMode === "Self-Served" ||props.isDisabled === "disabled"}
                            // className={`my-services-model-submit-btn conv-pr15 conv-pl15 conv-mt10 conv-mb10
                            // ${props.deliveryMode === "Self-Served" ||props.isDisabled === "disabled"?"disabled":""}`}
                            onClick={() => props.toggleModal()}
                        // disabled={props.deleteModalLoading ? true : false}
                        >
                            No
                        </Button>
                    </div>

                    <div style={{ color: "red", marginTop:"10px", marginBottom:"10px" }}>
                        <small>
                            <i>
                                <span><strong>Note: </strong></span>
                                {props.iconClickedName === "video" && (
                                    <span>
                                        Deleting a video testimonial is <strong>permanent</strong> and the file cannot be recovered.
                                    </span>
                                )}
                                {props.iconClickedName === "audio" && (
                                    <span>
                                        Deleting an audio testimonial is <strong>permanent</strong> and this action cannot be undone.
                                    </span>
                                )}
                                {props.iconClickedName === "text" && (
                                    <span>
                                        Deleting a text testimonial is <strong>permanent</strong> and the content cannot be restored.
                                    </span>
                                )}
                            </i>
                        </small>
                    </div>




                </div>

            </ModalContent>
        </Modal>
    );
}
